<template>
    <router-link
            v-if="isPersonRacer"
            class="link-person"
                 :class="{
                     'text-primary': gender !== 'z',
                     'text-danger': gender === 'z'
                 }"
                 :to="{name: 'person', params: {person}}"
                 @click.native.stop.prevent=""
    >
        {{ person }}
    </router-link>
    <span v-else>
        {{ person }}
    </span>
</template>

<script>
    export default {
        name: "LinkPerson",
        props: {
            person: {
                type: String,
                required: true
            },
            gender: {
                type: String,
                default: null
            },
        },
        computed: {
            isPersonRacer() {
                return this.$store.getters.resultsByPerson(this.person).length !== 0;
            }
        }
    };
</script>

<style scoped lang="scss">
    .link-person {

    }
</style>